// import { Link, Outlet, useParams, useLocation } from "react-router-dom";
// import { useEffect, useState } from "react";
// import axios from "axios";
// import "./ViewOrder.scss";
// import HeaderOne from "../../../HeaderOne";
// import Breadcrumb from "../../../Breadcrumb";
// import FooterOne from "../../../FooterOne";

// const API_URL = process.env.REACT_APP_API_URL;

// const ViewOrder = () => {
//   const { orderId } = useParams();
//   const location = useLocation();

//   const [order, setOrder] = useState(null);

//   const fetchOrder = async () => {
//     try {
//       const res = await axios.get(`${API_URL}/order/${orderId}`);
//       setOrder(res.data.data);
//     } catch (err) {
//       console.error("Error:", err);
//     }
//   };

//   useEffect(() => {
//     fetchOrder();
//   }, []);

//   const isActive = (tab) => location.pathname.includes(tab);

//   if (!order) return <p>Loading order details...</p>;

//   return (
//     <>
//     <HeaderOne/>

//     <Breadcrumb/>
//     <div className="view-order-container">

//       {/* ORDER SUMMARY HEADER */}
//       <h2 className="order-detail-title">Order #{order._id.slice(-6)}</h2>
//       <p className="order-date">
//         Placed on {new Date(order.createdAt).toLocaleString()}
//       </p>

//       {/* FULL ORDER DETAILS */}
//       <div className="order-info-box">

//         <div className="info-section">
//           <h3>Order Summary</h3>
//           <p><strong>Status:</strong> {order.status}</p>
//           <p><strong>Payment:</strong> {order.paymentMethod.toUpperCase()}</p>
//           <p><strong>Total Amount:</strong> ₹{order.totalAmount}</p>
//         </div>

//         <div className="info-section">
//           <h3>Billing Address</h3>
//           <p>{order.billing.firstName} {order.billing.lastName}</p>
//           <p>{order.billing.address1}</p>
//           <p>{order.billing.address2}</p>
//           <p>{order.billing.city}, {order.billing.state}</p>
//           <p>{order.billing.pincode}</p>
//           <p>{order.billing.phone}</p>
//         </div>

//         <div className="info-section">
//           <h3>Shipping Address</h3>
//           <p>{order.shipping.firstName} {order.shipping.lastName}</p>
//           <p>{order.shipping.address1}</p>
//           <p>{order.shipping.address2}</p>
//           <p>{order.shipping.city}, {order.shipping.state}</p>
//           <p>{order.shipping.pincode}</p>
//           <p>{order.shipping.phone}</p>
//         </div>

//         <div className="info-section">
//           <h3>Items</h3>
//           {order.items.map((item, i) => (
//             <div key={i} className="order-item-row">
//               <div>
//                 <p className="item-title">{item.name}</p>
//                 <p>Qty: {item.qty}</p>
//               </div>
//               <strong>₹{item.price * item.qty}</strong>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* TABS */}
//       <nav className="order-tabs">
//         <Link to="track" className={`tab-btn ${isActive("track") ? "active" : ""}`}>
//           Track Order
//         </Link>

//         <Link to="replace" className={`tab-btn ${isActive("replace") ? "active" : ""}`}>
//           Return / Replace
//         </Link>

//         <Link to="invoice" className={`tab-btn ${isActive("invoice") ? "active" : ""}`}>
//           Invoice
//         </Link>
//       </nav>

//       {/* TAB CONTENT */}
//       <div className="order-tab-content">
//         <Outlet />
//       </div>
//     </div>
//     <FooterOne/>
//     </>
//   );
// };

// export default ViewOrder;

import { Link, Outlet, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";
import FooterOne from "../../../FooterOne";

const API_URL = process.env.REACT_APP_API_URL;

const ViewOrder = () => {
  const { orderId } = useParams();
  const location = useLocation();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOrder = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/order/${orderId}`);
      setOrder(res.data.data);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, [orderId]);

  const isActive = (tab) => location.pathname.includes(tab);

  const getStatusColor = (status) => {
    const colors = {
      pending: '#f59e0b',
      processing: '#3b82f6',
      shipped: '#8b5cf6',
      delivered: '#10b981',
      cancelled: '#ef4444'
    };
    return colors[status?.toLowerCase()] || '#6b7280';
  };

  if (loading) {
    return (
      <>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
        <HeaderOne />
        <Breadcrumb />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: '1rem'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #e5e7eb',
            borderTopColor: '#111827',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p style={{ color: '#6b7280', fontSize: '1rem' }}>Loading order details...</p>
        </div>
        <FooterOne />
      </>
    );
  }

  if (!order) {
    return (
      <>
        <HeaderOne />
        <Breadcrumb />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          padding: '2rem'
        }}>
          <h3 style={{ color: '#111827', marginBottom: '0.5rem' }}>Order Not Found</h3>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>Unable to load order details</p>
          <Link to="/user/orders" style={{
            padding: '0.75rem 2rem',
            background: '#111827',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '6px',
            fontWeight: 500
          }}>
            Back to Orders
          </Link>
        </div>
        <FooterOne />
      </>
    );
  }

  return (
    <>
      <style>{`
        .view-order-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem 1rem;
          background: #f9fafb;
          min-height: 100vh;
        }

        .order-header-section {
          background: white;
          padding: 1.5rem;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          margin-bottom: 1.5rem;
        }

        .order-header-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-wrap: wrap;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        .order-id {
          font-size: 1.5rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 0.25rem 0;
        }

        .order-date-text {
          font-size: 0.875rem;
          color: #6b7280;
          margin: 0;
        }

        .status-badge-large {
          padding: 0.5rem 1rem;
          border-radius: 6px;
          font-size: 0.875rem;
          font-weight: 500;
          color: white;
          text-transform: capitalize;
        }

        .order-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .info-card {
          background: white;
          padding: 1.25rem;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
        }

        .info-card h3 {
          font-size: 1rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 1rem 0;
          padding-bottom: 0.75rem;
          border-bottom: 1px solid #e5e7eb;
        }

        .info-card p {
          font-size: 0.875rem;
          color: #6b7280;
          margin: 0 0 0.5rem 0;
          line-height: 1.5;
        }

        .info-card p strong {
          color: #111827;
          font-weight: 500;
        }

        .items-card {
          background: white;
          padding: 1.25rem;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          margin-bottom: 1.5rem;
        }

        .items-card h3 {
          font-size: 1rem;
          font-weight: 600;
          color: #111827;
          margin: 0 0 1rem 0;
          padding-bottom: 0.75rem;
          border-bottom: 1px solid #e5e7eb;
        }

        .order-item-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 1rem;
          background: #fafafa;
          border-radius: 6px;
          margin-bottom: 0.75rem;
          gap: 1rem;
        }

        .order-item-row:last-child {
          margin-bottom: 0;
        }

        .item-details h4 {
          font-size: 0.9375rem;
          font-weight: 500;
          color: #111827;
          margin: 0 0 0.375rem 0;
        }

        .item-details p {
          font-size: 0.8125rem;
          color: #6b7280;
          margin: 0;
        }

        .item-price {
          font-size: 1rem;
          font-weight: 600;
          color: #111827;
          white-space: nowrap;
        }

        .order-tabs-nav {
          background: white;
          padding: 0.5rem;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          margin-bottom: 1.5rem;
          display: flex;
          gap: 0.5rem;
          overflow-x: auto;
        }

        .order-tabs-nav::-webkit-scrollbar {
          height: 4px;
        }

        .order-tabs-nav::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 4px;
        }

        .tab-link {
          padding: 0.625rem 1.25rem;
          border-radius: 6px;
          text-decoration: none;
          color: #6b7280;
          font-weight: 500;
          font-size: 0.875rem;
          transition: all 0.2s ease;
          white-space: nowrap;
        }

        .tab-link:hover {
          background: #fafafa;
          color: #111827;
        }

        .tab-link.active {
          background: #111827;
          color: white;
        }

        .tab-content-section {
          background: white;
          padding: 1.5rem;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          min-height: 200px;
        }

        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.625rem 1.25rem;
          background: white;
          color: #111827;
          text-decoration: none;
          border-radius: 6px;
          border: 1px solid #e5e7eb;
          font-weight: 500;
          font-size: 0.875rem;
          transition: all 0.2s ease;
          margin-bottom: 1.5rem;
        }

        .back-button:hover {
          background: #fafafa;
          border-color: #d1d5db;
        }

        @media (max-width: 768px) {
          .view-order-wrapper {
            padding: 1rem 0.5rem;
          }

          .order-header-section {
            padding: 1rem;
          }

          .order-header-top {
            flex-direction: column;
          }

          .order-id {
            font-size: 1.25rem;
          }

          .order-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .info-card, .items-card {
            padding: 1rem;
          }

          .order-item-row {
            padding: 0.75rem;
          }

          .tab-content-section {
            padding: 1rem;
          }
        }

        @media (max-width: 480px) {
          .order-id {
            font-size: 1.125rem;
          }

          .order-item-row {
            flex-direction: column;
            align-items: flex-start;
          }

          .item-price {
            align-self: flex-end;
          }
        }
      `}</style>

      <HeaderOne />
      <Breadcrumb />

      <div className="view-order-wrapper">
        <Link to="/user/orders" className="back-button">
          ← Back to Orders
        </Link>

        {/* Order Header */}
        <div className="order-header-section">
          <div className="order-header-top">
            <div>
              <h2 className="order-id">Order #{order._id.slice(-8).toUpperCase()}</h2>
              <p className="order-date-text">
                Placed on {new Date(order.createdAt).toLocaleDateString('en-IN', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </p>
            </div>
            <span 
              className="status-badge-large"
              style={{ backgroundColor: getStatusColor(order.status) }}
            >
              {order.status}
            </span>
          </div>
        </div>

        {/* Order Info Grid */}
        <div className="order-grid">
          <div className="info-card">
            <h3>Order Summary</h3>
            <p><strong>Status:</strong> {order.status}</p>
            <p><strong>Payment:</strong> {order.paymentMethod.toUpperCase()}</p>
            <p><strong>Subtotal:</strong> {order.subtotal}</p>
            <p><strong>Tax:</strong> {order.tax}</p>
            <p><strong>Delivery:</strong> {order.delivery || 0}</p>
            <p><strong>Total Amount:</strong> {order.totalAmount}</p>
          </div>

          <div className="info-card">
            <h3>Billing Address</h3>
            <p><strong>{order.billing.firstName} {order.billing.lastName}</strong></p>
            <p>{order.billing.address1}</p>
            {order.billing.address2 && <p>{order.billing.address2}</p>}
            <p>{order.billing.city}, {order.billing.state}</p>
            <p>{order.billing.pincode}</p>
            <p><strong>Phone:</strong> {order.billing.phone}</p>
          </div>

          <div className="info-card">
            <h3>Shipping Address</h3>
            <p><strong>{order.shipping.firstName} {order.shipping.lastName}</strong></p>
            <p>{order.shipping.address1}</p>
            {order.shipping.address2 && <p>{order.shipping.address2}</p>}
            <p>{order.shipping.city}, {order.shipping.state}</p>
            <p>{order.shipping.pincode}</p>
            <p><strong>Phone:</strong> {order.shipping.phone}</p>
          </div>
        </div>

        {/* Items */}
        <div className="items-card">
          <h3>Order Items ({order.items.length})</h3>
          {order.items.map((item, i) => (
            <div key={i} className="order-item-row">
              <div className="item-details">
                <h4>{item.name}</h4>
                <p>Quantity: {item.qty} × {item.price}</p>
              </div>
              <div className="item-price">{item.price * item.qty}</div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <nav className="order-tabs-nav">
          <Link 
            to={`/user/orders/${orderId}/track`}
            className={`tab-link ${isActive("track") ? "active" : ""}`}
          >
            Track Order
          </Link>
          <Link 
            to={`/user/orders/${orderId}/cancel`}
            className={`tab-link ${isActive("replace") ? "active" : ""}`}
          >
            Cancel Order
          </Link>
          <Link 
            to={`/user/orders/${orderId}/return`}
            className={`tab-link ${isActive("replace") ? "active" : ""}`}
          >
            Return / Replace
          </Link>
          <Link 
            to={`/user/orders/${orderId}/invoice`}
            className={`tab-link ${isActive("invoice") ? "active" : ""}`}
          >
            Invoice
          </Link>
        </nav>

        {/* Tab Content */}
        <div className="tab-content-section">
          <Outlet context={{ order }} />
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default ViewOrder;
